"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.insetFocusRing = exports.focusVisibleClassName = exports.focusRing = void 0;
require("./focus.css");
var _tokens = require("../tokens");
const FOCUS_RING_PADDING = 4;
const FOCUS_RING_POSITION = `calc(-1 * (${FOCUS_RING_PADDING}px + ${_tokens.borderWidth.button}))`;
const INSET_FOCUS_RING_PADDING = 0;
const focusVisibleClassName = 'focus-visible';

/**
 * focusRing uses the focus-visible polyfill (since Safari does not yet support focus-visible)
 * @link https://github.com/WICG/focus-visible
 * this polyfill detects whether an interaction would have triggered the focus-visible property
 *  and adds the .focus-visible class
 */
exports.focusVisibleClassName = focusVisibleClassName;
const focusRing = "cds-focusRing-fd371rq";

/**
 * insetFocusRing uses the focus-visible polyfill (since Safari does not yet support focus-visible)
 * @link https://github.com/WICG/focus-visible
 * this polyfill detects whether an interaction would have triggered the focus-visible property
 *  and adds the .focus-visible class
 */
exports.focusRing = focusRing;
const insetFocusRing = "cds-insetFocusRing-ib8w4d5";
exports.insetFocusRing = insetFocusRing;